import type { BaseParams } from "../../../../client.types.js";
import type {
    IConfirmTransferBody,
    IConfirmTransferResponse204,
} from "../../../../routes/private/Ambassadors/Wallets/ConfirmTransfer/ConfirmTransfer.interfaces.js";
import { createAxiosRoute } from "../../../../utils/createAxiosRoute.js";

export const confirmTransfer = (p: BaseParams) =>
    createAxiosRoute<
        {
            body: IConfirmTransferBody;
        },
        IConfirmTransferResponse204
    >({
        ...p,
        method: "post",
        path: "/api/ambassadors/wallets/confirmTransfer",
    });
